import jwtDecode from 'jwt-decode';
import { MESSENGER_NAME_STORAGE_KEY } from 'consts';

export const getNameFromToken = (token: string) => {
    const decoded = jwtDecode(token) as any;
    const metadata = decoded?.metadata;

    if (metadata) {
        const metadataParsed = JSON.parse(metadata);
        const userDetails = metadataParsed.userDetails;

        const { firstName, lastName } = userDetails;
        const name = `${firstName} ${lastName}`;
        sessionStorage.setItem(MESSENGER_NAME_STORAGE_KEY, name);

        return name;
    }

    return '';
};
